module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_android_contacts.846e8a8e926a8df2025df3027000f7cf.png";